import { render } from "./TheSnake.vue?vue&type=template&id=58564175&scoped=true"
import script from "./TheSnake.vue?vue&type=script&lang=js"
export * from "./TheSnake.vue?vue&type=script&lang=js"

import "./TheSnake.vue?vue&type=style&index=0&id=58564175&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-58564175"

export default script